export enum MraAbcdScore {
    A = 'A: Lichte ziektelast - AHI < 15',
    B = 'B: Matige/ernstige ziektelast - AHI < 15',
    C = 'C: Lichte ziektelast - AHI ≥ 15',
    D = 'D: Matige/ernstige ziektelast - AHI ≥ 15',
}
